import React from "react";
import "./style.css";

const MCsPoints = () => {
  return (
    <div className="mcs-points-container">
      <p className="mcs-points-description">
        The MCs point system is integrated with the Money Miners where you can
        invest these points to grow them more on the system mimicking the real
        life charts.
      </p>
      <p className="mcs-points-action">
        Grow your MCs and redeem the exclusive brand vouchers in collaboration
        with us.
      </p>
    </div>
  );
};

export default MCsPoints;
